import { Injectable } from '@angular/core'

@Injectable({
  providedIn: 'root',
})
export class BackendTranslationService {
  private translations: Map<string, string> = new Map([
    // Authentication & User related
    [
      'Password failure 1/5. You will be blocked after 5 failures.',
      $localize`Password failure 1/5. You will be blocked after 5 failures.`,
    ],
    [
      'Password failure 2/5. You will be blocked after 5 failures.',
      $localize`Password failure 2/5. You will be blocked after 5 failures.`,
    ],
    [
      'Password failure 3/5. You will be blocked after 5 failures.',
      $localize`Password failure 3/5. You will be blocked after 5 failures.`,
    ],
    [
      'Password failure 4/5. You will be blocked after 5 failures.',
      $localize`Password failure 4/5. You will be blocked after 5 failures.`,
    ],
    [
      'Password failure 5/5. You will be blocked after 5 failures.',
      $localize`Password failure 5/5. You will be blocked after 5 failures.`,
    ],
    [
      'Email failure 1/10. You will be blocked after 10 failures.',
      $localize`Email failure 1/10. You will be blocked after 10 failures.`,
    ],
    [
      'Email failure 2/10. You will be blocked after 10 failures.',
      $localize`Email failure 2/10. You will be blocked after 10 failures.`,
    ],
    [
      'Email failure 3/10. You will be blocked after 10 failures.',
      $localize`Email failure 3/10. You will be blocked after 10 failures.`,
    ],
    [
      'Email failure 4/10. You will be blocked after 10 failures.',
      $localize`Email failure 4/10. You will be blocked after 10 failures.`,
    ],
    [
      'Email failure 5/10. You will be blocked after 10 failures.',
      $localize`Email failure 5/10. You will be blocked after 10 failures.`,
    ],
    [
      'Email failure 6/10. You will be blocked after 10 failures.',
      $localize`Email failure 6/10. You will be blocked after 10 failures.`,
    ],
    [
      'Email failure 7/10. You will be blocked after 10 failures.',
      $localize`Email failure 7/10. You will be blocked after 10 failures.`,
    ],
    [
      'Email failure 8/10. You will be blocked after 10 failures.',
      $localize`Email failure 8/10. You will be blocked after 10 failures.`,
    ],
    [
      'Email failure 9/10. You will be blocked after 10 failures.',
      $localize`Email failure 9/10. You will be blocked after 10 failures.`,
    ],
    [
      'Email failure 10/10. You will be blocked after 10 failures.',
      $localize`Email failure 10/10. You will be blocked after 10 failures.`,
    ],
    [
      'Your IP address is blocked. Please contact support.',
      $localize`Your IP address is blocked. Please contact support.`,
    ],
  ])

  /**
   * Translate a backend message key to localized string
   * @param backendKey - The key/message from backend
   * @returns Translated string or original key if no translation found
   */
  translate(backendKey: string): string {
    if (!backendKey) {
      return ''
    }

    // Try exact match first
    if (this.translations.has(backendKey)) {
      return this.translations.get(backendKey)!
    }

    // Return original if no translation found
    return backendKey
  }
}
